import React, { Component } from 'react';

export default class Header extends Component {
    render() {
        return (
            <div className='Banner-img'>
                <div className='banner-head'>
                Maeve Lifestyle
                </div>
            </div>
        )
    }
}
